package org.molap.geojson

import com.macrofocus.common.json.JsonObject
import org.molap.dataframe.DataFrame

fun DataFrame.Companion.readGeoJson(json: JsonObject): GeoJSONDataFrame {
    return GeoJSONDataFrame(json)
}

